import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  resetPasswordAPI,
} from "./Servicefile/authService.jsx";

const ResetPassword = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const [hidePassword, setHidePassword] = useState(true);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate(); // hook for navigation

  const handleReset = async (
    e
  ) => {
    e.preventDefault();

    if (
      !newPassword ||
      !confirmPassword
    ) {
      setError(
        "Both fields are required."
      );

      return;
    }

    if (
      newPassword !==
      confirmPassword
    ) {
      setError(
        "Passwords do not match."
      );

      return;
    }

    try {
      const message =
        await resetPasswordAPI({
          token,
          newPassword,
          confirmPassword,
        });

      alert(message);

      setMessage(message);

      navigate("/");

      setError("");

    } catch (err) {
      setError(
        err.message ||
        "Something went wrong."
      );
    }
  };

  return (
    <div style={styles.container}>
      <h2>Reset Your Password</h2>

      <form onSubmit={handleReset}>
        {" "}
        {/* Ensure the form tag wraps around the input fields */}
        <div
          style={{ position: "relative", marginBottom: "20px", width: "100%" }}
        >
          <input
            type={hidePassword ? "password" : "text"}
            // type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={styles.input}
            required
            autoComplete="new-password" // Added for better accessibility
          />
          <span
            onClick={() => setHidePassword((prev) => !prev)}
            style={{
              position: "absolute",
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#555",
            }}
          >
            {hidePassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>
        <div
          style={{ position: "relative", marginBottom: "20px", width: "100%" }}
        >
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={styles.input}
            required
            autoComplete="new-password" // Added for better accessibility
          />
          <span
            onClick={() => setHidePassword((prev) => !prev)}
            style={{
              position: "absolute",
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#555",
            }}
          >
            {hidePassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>
        <button type="submit" style={styles.button}>
          Reset Password
        </button>
      </form>

      {message && <p style={{ color: "green" }}>{message}</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "400px",
    margin: "100px auto",
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    textAlign: "center",
    fontFamily: "sans-serif",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "15px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  button: {
    width: "100%",
    padding: "10px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default ResetPassword;
